import { qantasHotels } from '@qga/roo-ui/logos';
import { rem } from 'polished';
import styled from '@emotion/styled';
import { Container, Flex, Link } from '@qga/roo-ui/components';
import { QH_HOMEPAGE_URL } from '../../../lib/config';
import { PhoneMenu } from './PhoneMenu';
import { QffMenu } from './QffMenu';
import { themeGet } from 'styled-system';
import { HeaderProps } from '../types';
import { LoginTooltip } from '../LoginTooltip';
import { useHeaderContext } from '../HeaderContext';
import { isArray, head } from 'lodash';
import type { FC } from 'react';

const qantasLogoClip = '71px';

export const HeaderPhone: FC<HeaderProps> = ({
  universalNavEnabled = true,
  qffLoginEnabled = true,
  homepageUrl = QH_HOMEPAGE_URL,
  homepageLogoSrc = qantasHotels,
  homepageLogoLabel = 'Qantas',
  LogoItemRenderer = Logo,
  navEnabled = true,
  arrowDirection = 'up',
}) => {
  const { onInteraction } = useHeaderContext();

  const tooltipArrowDirection = isArray(arrowDirection)
    ? head(arrowDirection)
    : arrowDirection;

  const trackIteraction = () => {
    onInteraction({ type: 'Phone Header Logo', value: 'Selected' });
  };

  return (
    <Container p={0}>
      {navEnabled && (
        <HeaderInner>
          <Flex alignItems="center">
            <Link
              href={homepageUrl}
              mr={4}
              p={1}
              data-testid="header-logo-link"
              onClick={trackIteraction}
            >
              <LogoItemRenderer
                src={homepageLogoSrc}
                alt={homepageLogoLabel}
                role="img"
                aria-label={`${homepageLogoLabel} Logo`}
              />
            </Link>
          </Flex>
          <Flex data-print-style="hidden" data-testid="phone-menus">
            <PhoneMenu
              qffLoginEnabled={qffLoginEnabled}
              universalNavEnabled={universalNavEnabled}
            />
            {qffLoginEnabled && <QffMenu />}
          </Flex>
        </HeaderInner>
      )}

      {qffLoginEnabled && (
        <LoginTooltip arrowDirection={tooltipArrowDirection} />
      )}
    </Container>
  );
};

const Logo = styled.img`
  display: inline-flex;
  clip-path: inset(0 0 -1px ${qantasLogoClip});
  margin-left: -${qantasLogoClip};
  ${themeGet('mediaQueries.1')} {
    width: ${rem('186px')};
  }
`;

const HeaderInner = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  padding-left: ${themeGet('space.4')};
  border-bottom: 1px solid ${themeGet('colors.greys.porcelain')};
`;
